/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_TitleInputs */

const en_admin_roles_title = /** @type {(inputs: Admin_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Admin_Roles_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_title = /** @type {((inputs?: Admin_Roles_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_title(inputs)
});
export { admin_roles_title as "admin.roles.title" }